import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

import * as tooltipService from '../services/tooltip-service'

export default class IconTooltip extends React.Component {
  constructor (props, context) {
    super(props, context)
    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.state = { show: false, text: '' }
  }

  componentDidMount () {
    if (this.props.id) {
      tooltipService.get(this.props.id).then(tooltip => this.setState({ text: tooltip.description }))
    } else {
      this.setState({ text: this.props.text })
    }
  }

  componentDidUpdate (prevProps) {
    // get the tooltip text from the database when an id is specified, or the text directly when it was hardcoded

    if (this.props.id !== prevProps.id) {
      tooltipService.get(this.props.id).then(tooltip => this.setState({ text: tooltip.description }))
    }

    if (this.props.text !== prevProps.text) {
      this.setState({ text: this.props.text })
    }
  }

  handleShow () {
    this.setState({ show: true })
  }

  handleHide () {
    this.setState({ show: false })
  }

  render () {
    const { icon, warningIcon } = this.props
    let tooltipId = Math.floor(Math.random() * (999 - 1)) + 1

    const { text } = this.state

    return (
      <div className='icon-container'>
        { text &&
        <Button onClick={this.handleShow}>
          <span className='info-icon'><FontAwesome name={icon} className='cursor' /></span>
        </Button>}
        <Modal
          {...this.props}
          show={this.state.show}
          onHide={this.handleHide}
          dialogClassName='info-window'
          backdrop={false}
          id={`tooltip-${tooltipId}`}>
          <Modal.Header closeButton>
            <span className='info' />
            {warningIcon && <span className='warning'><i /></span>}
          </Modal.Header>
          <Modal.Body>
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/IconTooltip.js